import React from 'react';

/**
 * ClockCheck icon
 * @param {React.SVGProps<SVGSVGElement>} props
 * @returns
 */
function ClockCheck(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9.917 9.5l-2.25-.75V5.614m6 2.386a6 6 0 10-4.875 5.895m1.5-1.77l1.124 1.125 3-3"
      ></path>
    </svg>
  );
}

export default ClockCheck;
